module.exports = __webpack_public_path__ + "img/plus.f1e44e02.svg";